import projectIcon from "../../../assets/icon-project.png";
import indiaIcon from "../../../assets/india icon.png";
import issueIcon from "../../../assets/icon-issue.png";
import nodalIcon from "../../../assets/icon-nodal.png";
import downloadIcon from "../../../assets/icon-download-mis.png";
import documentIcon from "../../../assets/icon-document.png";
import chartIcon from "../../../assets/icon-chart.png";

const MisDropDownOptions = [
  {
    title: "State Profile",
    icon: indiaIcon,
    expandView: true,
    classes: "project-type",
    dropDown: [
      {
        title: "State Summary",
        view: "STATE_SUMMARY"
      },
      {
        title: "Meetings Summary",
        view: "MEETINGS_SUMMARY"
      },
      {
        title: "State Data Compliance",
        view: "STATE_DATA_COMPLIANCE"
      }
    ]
  },
  {
    title: "Projects",
    icon: projectIcon,
    expandView: false,
    classes: "project-type",
    dropDown: [
      {
        title: "Projects Summary",
        view: "PROJECT_SUMMARY"
      },
      {
        title: "Ministry Report",
        view: "MINISTRY_REPORT"
      },
      {
        title: "Ministry Data Compliance",
        view: "MINISTRY_COMPLIANCE"
      }
    ]
  },
  {
    title: "Issues",
    icon: issueIcon,
    expandView: false,
    dropDown: [
      {
        title: "Issues Summary",
        view: "FLAT_FILE"
      },
      {
        title: "Ministry/State Agenda",
        view: "ISSUE_STATE"
      }
    ]
  },
  {
    title: "Nodal Officers",
    icon: nodalIcon,
    expandView: false,
    dropDown: [
      {
        title: "Summary",
        view: "NODAL_OFFICER"
      }
    ]
  },
  {
    title: "Download",
    icon: downloadIcon,
    expandView: false,
    dropDown: [
      {
        title: "Reports",
        view: "DOWNLOAD_REPORT"
      }
      // {
      //   title: "User Manual",
      //   view: "DOWNLOAD_MANUAL"
      // }
    ]
  },
  {
    title: "Documents",
    icon: documentIcon,
    expandView: false,
    dropDown: [
      {
        title: "Attachments",
        view: "DOCUMENT_ATTACHMENTS"
      },
      {
        title: "Dashboard Summary",
        view: "DASHBOARD_SUMMARY"
      }
      // {
      //   title: "Monthly Newsletter",
      //   view: "MONTHLY_NEWSLETTER"
      // }
    ]
  },
  {
    title: "Download Charts",
    icon: chartIcon,
    expandView: false,
    dropDown: [
      {
        title: "Charts",
        view: "CHARTS"
      }
    ]
  }
];

export { MisDropDownOptions };
